// Maximum records returned by search queries in .graphql file
export const MAX_ITEM_AGGREGATE = 1000;
